<template>
  <div>
    <section class="content-header mt-2">
      <div v-if="edit">
        <h3 class="pull-left">
          <font-awesome-icon icon="database" /> Edit Connection
        </h3>
        <b-button
          v-b-tooltip.hover
          class="btn btn-success pull-right"
          title="create another"
          @click="create">
          <font-awesome-icon icon="plus" />
        </b-button>
      </div>
      <div v-else>
        <h3 class="pull-left">
          <font-awesome-icon icon="database" /> Create Connection
        </h3>
      </div>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-md-6">
          <error-component
            v-if="exceptions.length > 0"
            :margin-x="'mx-0'"
            v-bind="exceptions[0]" />
          <success-component
            v-if="success.length > 0"
            :message="success" />
          <b-form @submit.prevent="submit">
            <b-form-group
              id="nameGroup"
              label="Name:"
              label-for="name"
              description="">
              <b-form-input
                id="name"
                v-model="connection.name"
                v-validate="'required'"
                name="name"
                type="text"
                placeholder=""
                :state="errors.has('name') ? false: null" />
              <em
                v-if="errors.has('name')"
                class="text-danger">{{ errors.first('name') }}</em>
            </b-form-group>
            <b-form-group
              id="typeGroup"
              label="Type:"
              label-for="type">
              <b-form-select
                id="type"
                v-model="connection.type"
                v-validate="'required'"
                name="type"
                :options="types"
                :state="errors.has('type') ? false: null"
                @input="setPort()" />
              <em
                v-if="errors.has('type')"
                class="text-danger">{{ errors.first('type') }}</em>
            </b-form-group>
            <b-form-group
              id="portGroup"
              label="Port:"
              label-for="port"
              description="">
              <b-form-input
                id="port"
                v-model="connection.port"
                v-validate="{required: true, numeric: true}"
                name="port"
                type="text"
                placeholder=""
                :state="errors.has('port') ? false: null" />
              <em
                v-if="errors.has('port')"
                class="text-danger">{{ errors.first('port') }}</em>
            </b-form-group>
            <b-form-group
              id="hostGroup"
              label="Host:"
              label-for="host"
              description="">
              <b-form-input
                id="host"
                v-model="connection.host"
                v-validate="'required'"
                name="host"
                type="text"
                placeholder=""
                :state="errors.has('host') ? false: null" />
              <em
                v-if="errors.has('host')"
                class="text-danger">{{ errors.first('host') }}</em>
            </b-form-group>
            <b-form-group
              id="usernameGroup"
              label="Username:"
              label-for="username"
              description="">
              <b-form-input
                id="username"
                v-model="connection.username"
                v-validate="'required'"
                name="username"
                type="text"
                placeholder=""
                :state="errors.has('username') ? false: null" />
              <em
                v-if="errors.has('username')"
                class="text-danger">{{ errors.first('username') }}</em>
            </b-form-group>
            <b-form-group
              id="passwordGroup"
              label="Password:"
              label-for="password"
              description="">
              <b-form-input
                id="password"
                v-model="connection.password"
                v-validate="connectionId? '': 'required'"
                name="password"
                type="password"
                placeholder=""
                :state="errors.has('password') ? false: null" />
              <em
                v-if="errors.has('password')"
                class="text-danger">{{ errors.first('password') }}</em>
            </b-form-group>
            <b-form-group
              id="databaseGroup"
              label="Database:"
              label-for="database"
              description="">
              <b-form-input
                id="database"
                v-model="connection.database"
                v-validate="'required'"
                name="database"
                type="text"
                placeholder=""
                :state="errors.has('database') ? false: null" />
              <em
                v-if="errors.has('database')"
                class="text-danger">{{ errors.first('database') }}</em>
            </b-form-group>
            <b-button
              type="reset"
              class="mr-2"
              variant="secondary"
              @click.prevent="getBack">
              <font-awesome-icon icon="arrow-left" /> Back
            </b-button>
            <b-button
              v-b-tooltip.hover
              variant="info"
              :disabled="loading.test"
              class="mr-2"
              title="Check if this is a valid connection"
              @click.prevent="checkConnection()">
              <span>Test Connection</span>
              <b-spinner
                v-if="loading.test"
                small
                class="ml-2" />
            </b-button>
            <b-button
              type="submit"
              variant="success"
              :disabled="loading.submit">
              <font-awesome-icon
                icon="save"
                class="mr-1" /> Submit
              <b-spinner
                v-if="loading.submit"
                small
                class="ml-2" />
            </b-button>
          </b-form>
        </div>
        <div class="col-md-4 help onboarding">
          <h4>👩‍🏫 ‍Need a database to play?</h4>
          <div class="info">
            If you don't have a connection but you want to evaluate Data Providers, you can use
            this database that we have for demos and tests, here are the credentials.<br>
            The database is basic retail model, with orders and orders details and more.
          </div>
          <div>
            <h5>ℹ️ Demo Connection Details</h5>
            <div>
              <label>Type:</label> Mysql
            </div>
            <div>
              <label>Server:</label> demodb.dataproviders.io
            </div>

            <div>
              <label>Port:</label> 3306
            </div>
            <div>
              <label>Database:</label> northwind
            </div>
            <div>
              <label>User :</label> northwind
            </div>
            <div>
              <label>Password :</label> vcLawe34994859!
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import SuccessComponent from '../../components/Success.vue';
  import ErrorComponent from '../../components/ErrorView.vue';

  import { mapState } from 'vuex';

  export default {
    components: {
      SuccessComponent,
      ErrorComponent
    },
    $_veeValidate: {
      validator: 'new'
    },
    data() {
      return {
        connection: {
          organization_id: this.$store.state.organizationSelected,
          name: '',
          type: '',
          host: '',
          username: '',
          password: '',
          database: '',
          port: ''
        },
        connectionId: this.$route.params.connectionId,
        types: [],
        edit: !!this.$route.params.connectionId,
        unwatch: '',
        loading: {
          submit: false,
          test: false,
        }
      };
    },
    computed: {
      ...mapState('connections',{
        connections: 'items',
        storeConnection: 'connection',
        storeTypes: 'types'
      }),
      ...mapState({
        success: 'success',
        exceptions: 'exceptions'
      })
    },
    created() {
      this.$store.dispatch('connections/getTypes')
        .then(()=> {
          const types = {}
          for (const type in this.storeTypes) {
            types[type] = {
              text: this.storeTypes[type].name,
              port: this.storeTypes[type].port,
            }
          }
          this.types = types;
        });
      if (this.connectionId) {
        this.$store.dispatch('connections/show', this.connectionId)
          .then(() => {
            this.connection = this.storeConnection;
          });
      }
      this.unwatch = this.$store.watch(
        (state) =>
          this.$store.state.organizationSelected
        ,
        (newValue, oldValue) => {
          this.$store.dispatch('clearMessages');
          this.$store.commit('connections/SET_TYPES', []);
          this.$store.dispatch('connections/getTypes')
            .then(()=> {
              this.types = this.storeTypes;
            });
          this.$router.replace({ name: 'connection.create' });
          this.edit = false;
          this.setInitialStatus();
        },
      );
    },
    beforeDestroy() {
      this.$store.dispatch('clearMessages');
      this.$store.commit('connections/SET_TYPES', []);
      this.unwatch();
    },
    methods: {
      checkConnection() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading.test = true;
            this.$store.dispatch('connections/checkConnection', this.connection).finally(() => {
              this.loading.test = false;
            });
          }
        });
      },
      create() {
        this.$store.dispatch('clearMessages');
        this.edit = false;
        this.setInitialStatus();
        this.$validator.reset();
        this.$router.replace({ name: 'connection.create' });
      },
      getBack() {
        this.$router.push({ name: 'connection' });
      },
      setInitialStatus() {
        this.connection = {
          organization_id: this.$store.state.organizationSelected,
          name: '',
          type: '',
          host: '',
          username: '',
          password: '',
          database: '',
          port: ''
        }
      },
      submit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading.submit = true;
            if(this.connectionId) {
              this.$store.dispatch('connections/edit', { id: this.connectionId, connection: this.connection }).finally(() => {
                this.loading.submit = false;
              });
            } else {
              this.$store.dispatch('connections/create', this.connection).finally(() => {
                this.loading.submit = false;
              });
            }
          }
        });
      },
      setPort(value) {
        if (!this.connectionId && this.types[`${this.connection.type}`].port !== 0) {
          this.connection.port = this.types[`${this.connection.type}`].port;
        }
      },
    },
  }
</script>
